import custom from './custom';
import ValidationMaxAmount from '../components/ValidationMaxAmount';

export const insufficient = () => custom.error(ValidationMaxAmount);
